import React from 'react'
import { useQuery } from '@tanstack/react-query';
import fitdocApi from '../../lib/axios';
import { getDocomsTrans } from '../../lib/trans';
import { ReactSession }  from 'react-client-session';

type Props = {
    doctype?: string | null
}

const DoctypeLabel = ({doctype, ...props}:Props & React.HTMLAttributes<HTMLParagraphElement>) => {
    const language = ReactSession.get("language");

    const { data:doctypes } = useQuery({
        queryKey: ['doctypes'],
        queryFn: async () => {
            const {data:dt} = await fitdocApi.get('doctypes/list')
            if(dt.errorcode!==0)  throw new Error('Error fetching doctypes');
            if(!Array.isArray(dt.object)) throw new Error('Error fetching doctypes');
            return dt.object;
        }
    })

    const dt = doctypes?.find((d:any) => d.doctype === doctype)
    const label = dt ? getDocomsTrans(dt.docoms, language) : ""

  return (
    <p {...props}>{label}</p>
  )
}

export { DoctypeLabel }